/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Trick-play / transport states for video playback.
 * Represents the current transport mode of the player including rewind, fast-forward, and standard states.
 */
export enum PlaybackState {
  /**
   * Rewinding at 3x speed (fastest rewind).
   */
  RW3 = "RW3",

  /**
   * Rewinding at 2x speed.
   */
  RW2 = "RW2",

  /**
   * Rewinding at 1x speed (slowest rewind).
   */
  RW1 = "RW1",

  /**
   * Playback is paused.
   */
  PAUSE = "PAUSE",

  /**
   * Standard playback at 1x speed.
   */
  PLAY = "PLAY",

  /**
   * Fast-forwarding at 1x speed (slowest fast-forward).
   */
  FF1 = "FF1",

  /**
   * Fast-forwarding at 2x speed.
   */
  FF2 = "FF2",

  /**
   * Fast-forwarding at 3x speed (fastest fast-forward).
   */
  FF3 = "FF3",

  /**
   * Playback is stopped.
   */
  STOP = "STOP"
}
